/**
 * Moves a step index past any disabled steps in the direction of travel. A wizard's first and last
 * steps are never disabled, so the result always lands on a real step.
 */
export var skipDisabledSteps = function (steps, stepIndex, disabledSteps, direction) {
    if (direction === void 0) { direction = 1; }
    var nextIndex = stepIndex;
    while (nextIndex > 0 && nextIndex < steps.length - 1 && disabledSteps.includes(steps[nextIndex])) {
        nextIndex += direction;
    }
    return nextIndex;
};
